export default __webpack_public_path__ + "static/Fellix-Regular-af2bee556f001452e682036b763c99c1.otf";